export const style = {
  th: {
    fontSize: `14px`,
    fontWeight: 700,
    borderBottom: `2px solid #ddd`,
    borderTop: 0,
    lineHeight: `1.4`,
    padding: `8px`
  },
  tr: {
    cursor: `pointer`,
    ':hover': {
      background: `#f5f5f5`
    }
  },
  td: {
    fontSize: `14px`,
    fontWeight: 400,
    padding: `8px`,
    lineHeight: `1.4`,
    borderTop: `1px solid #ddd`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Settings/Main/style/table.js